import office from '@/taskpane/officejs/office-wrapper'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'

interface RetrieveDraftEventIdCallbackArgs extends CallbackArgs {
  eventId: string
}

export default async function retrieveDraftEventIdHandler() {
  const callbackArgs = defaultCallbackArgs() as RetrieveDraftEventIdCallbackArgs

  try {
    let id = await office.id()

    if (!id) {
      id = await office.save()
    }

    callbackArgs.eventId = id
  } catch (error) {
    callbackArgs.errorCode = 500
    callbackArgs.errorMessage = error || 'Failed to retrieve draft event Id'
  } finally {
    sendMessageToSidebar('RetrieveDraftEventIdCallback', callbackArgs)
  }
}
